import { render, staticRenderFns } from "./PendingInformation.vue?vue&type=template&id=34871c42"
import script from "./PendingInformation.vue?vue&type=script&lang=js"
export * from "./PendingInformation.vue?vue&type=script&lang=js"
import style0 from "./PendingInformation.vue?vue&type=style&index=0&id=34871c42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports